import { makeStyles, css } from '@conexasaude/hero'

const breadcrumbStyle = makeStyles({
  breadcrumbContainer({ colors }) {
    return css`
      display: flex;
      padding-bottom: 16px;
      margin-bottom: 20px;
      border-bottom: 1px solid ${colors.neutral[200]};
      a {
        padding: 0 10px;
        color: ${colors.neutral[500]};
        text-decoration: underline;
        &:first-of-type {
          padding-left: unset;
        }
        &:hover {
          color: ${colors.neutral[400]};
        }
      }
      li {
        display: flex;
        align-items: center;
      }
      .current-step {
        font-size: 14px;
        color: ${colors.neutral[900]};
        font-weight: 600;
      }
      @media (max-width: 639px) {
        display: none;
      }
    `
  },
  backStepContainer() {
    return css`
      display: flex;
      margin-bottom: 10px;
    `
  },
})

export default breadcrumbStyle
